<template>
    <section>
        <div class="mask choose-hotel" >
            <div class="e-modal medium">
                <div class="e-modal-title">选择酒店</div>
                <div class="e-modal-body">
                    <div class="action">
                        <p>共<span class="color-1478e4">{{hotelList.length}}</span>个产品</p>
                        <div class="search-box">
                            <!--<input type="text"  v-model="hotelName" @keyup.enter="initData">-->
                            <input type="text" v-model="hotelName" @keyup.enter="initData" placeholder="酒店名称" style="padding-left: 15px;">
                            <span class="search-btn" @click="initData">搜索</span>
                            <div class="action-btn" v-if="userHasPersission(3)" @click="pageTo('/order')">订单处理</div>
                            <div class="action-btn" v-if="userHasPersission(7)" @click="pageTo('/payments')">查看付款水单</div>
                            <div class="action-btn" v-if="userHasPersission(20)" @click="pageTo('/veri')">预约核销</div>
                        </div>
                    </div>
                    <div class="table-box-hack">
                        <table class="stripe" cellspacing="0">
                            <tr style="font-weight: 600;">
                                <td width="20%">酒店代码</td>
                                <td width="40%">酒店名称</td>
                                <td width="15%">城市</td>
                                <td width="25%">区域</td>
                            </tr>
                            <tr v-if="!hotelList">
                                <td colspan="4" >没有相关数据...</td>
                            </tr>
                            <tr v-for="item in hotelList" v-if="hotelList&&hotelList.length>0" @click="toRoomStatus(item)">
                                <td>{{item.HotelId}}</td>
                                <td>{{item.HotelName}}</td>
                                <td>{{item.CityName}}</td>
                                <td>{{item.DistrictName}}</td>
                            </tr>
                         
                        </table>
                      </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      hotelName: '',
      hotelList:'',
      isLoading:false,
      userInfo:JSON.parse(this.dao.get('res')),
    }
  },
  beforeCreate(){
      
    this.dao.set('activePage','/index');
  },
  methods:{
      initData () {
        var that=this;
        var params={
          name: that.hotelName
        }
        that.hotelList='';
        that.isLoading = true;
        that.getRequest({
            url: that.Api.getHotelList,
            params: params
        }).then(res => {
            that.isLoading = false;
            if (res && res.Result && res.Total > 0) {
               
                that.hotelList=res.Result;
            } else {
                that.hotelList='';
                // that.error({ title: '提示', content: '没有查询到相关数据' });
            }
        });
      },
      userHasPersission(pms){
          return this.userInfo.Permissions&&this.userInfo.Permissions.indexOf(pms)>-1?true:false;
      },
      pageTo(url){
          this.$router.push(url);
      },
      toRoomStatus(item){
       
          if(this.userHasPersission(5)){
              this.dao.set('HotelName',item.HotelName)
              this.dao.set('HotelId',item.HotelId)
              this.$router.push('/roomPriceAndStatus');
          }else{
              this.error({ title: '提示', content:'您没有酒店查看权限，请联系主帐号！' });
          }
    

      }
  },

  mounted(){
      this.initData();
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Index.vue